import { render, staticRenderFns } from "./ConfiguracaoCobrancaTabela.vue?vue&type=template&id=bb4f41f4&"
import script from "./ConfiguracaoCobrancaTabela.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoCobrancaTabela.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoCobrancaTabela.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports